module.exports = __webpack_public_path__ + "static/media/hazmat.362ab760.svg";